import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19b2f785"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chart-style-panel" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 编辑图表数据 ")
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("面积图样式")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("散点图样式")
const _hoisted_6 = { class: "row" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("使用平滑曲线")
const _hoisted_8 = {
  key: 1,
  class: "row"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("条形图样式")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("堆叠样式")
const _hoisted_11 = {
  key: 2,
  class: "row"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("环形图样式")
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "图例：", -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode("不显示")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("显示在上方")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("显示在下方")
const _hoisted_18 = { class: "row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "背景填充：", -1))
const _hoisted_20 = { class: "row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "网格颜色：", -1))
const _hoisted_22 = { style: {"flex":"2"} }
const _hoisted_23 = {
  class: "color-btn-wrap",
  style: {"flex":"3"}
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "preset-themes" }
const _hoisted_26 = ["onClick", "onMouseenter"]
const _hoisted_27 = /*#__PURE__*/_createTextVNode("推荐主题")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 添加主题色 ")

import { onUnmounted, Ref, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { ChartData, ChartOptions, PPTChartElement } from '@/types/slides'
import emitter, { EmitterEvents } from '@/utils/emitter'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import ElementOutline from '../../common/ElementOutline.vue'
import ColorButton from '../../common/ColorButton.vue'
import ChartDataEditor from './ChartDataEditor.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const presetChartThemes = [
  ['#d87c7c', '#919e8b', '#d7ab82', '#6e7074', '#61a0a8', '#efa18d'],
  ['#dd6b66', '#759aa0', '#e69d87', '#8dc1a9', '#ea7e53', '#eedd78'],
  ['#516b91', '#59c4e6', '#edafda', '#93b7e3', '#a5e7f0', '#cbb0e3'],
  ['#893448', '#d95850', '#eb8146', '#ffb248', '#f2d643', '#ebdba4'],
  ['#4ea397', '#22c3aa', '#7bd9a5', '#d0648a', '#f58db2', '#f2b3c9'],
  ['#3fb1e3', '#6be6c1', '#626c91', '#a0a7e6', '#c4ebad', '#96dee8'],
  ['#fc97af', '#87f7cf', '#f7f494', '#72ccff', '#f7c5a0', '#d4a4eb'],
  ['#c1232b', '#27727b', '#fcce10', '#e87c25', '#b5c334', '#fe8463'],
  ['#2ec7c9', '#b6a2de', '#5ab1ef', '#ffb980', '#d87a80', '#8d98b3'],
  ['#e01f54', '#001852', '#f5e8c8', '#b8d2c7', '#c6b38e', '#a4d8c2'],
  ['#c12e34', '#e6b600', '#0098d9', '#2b821d', '#005eaa', '#339ca8'],
  ['#8a7ca8', '#e098c7', '#8fd3e8', '#71669e', '#cc70af', '#7cb4cc'],
]

const mainStore = useMainStore()
const slidesStore = useSlidesStore()
const { handleElement, handleElementId } = storeToRefs(mainStore)
const { theme } = storeToRefs(slidesStore)

const handleChartElement = handleElement as Ref<PPTChartElement>

const chartDataEditorVisible = ref(false)
const presetThemesVisible = ref(false)
const presetThemeColorHoverIndex = ref<[number, number]>([-1, -1])

const { addHistorySnapshot } = useHistorySnapshot()

const fill = ref<string>('#000')

const themeColor = ref<string[]>([])
const gridColor = ref('')
const legend = ref('')

const lineSmooth = ref(true)
const showLine = ref(true)
const showArea = ref(false)
const horizontalBars = ref(false)
const donut = ref(false)
const stackBars = ref(false)

watch(handleElement, () => {
  if (!handleElement.value || handleElement.value.type !== 'chart') return
  fill.value = handleElement.value.fill || '#fff'

  if (handleElement.value.options) {
    const {
      lineSmooth: _lineSmooth,
      showLine: _showLine,
      showArea: _showArea,
      horizontalBars: _horizontalBars,
      donut: _donut,
      stackBars: _stackBars,
    } = handleElement.value.options

    if (_lineSmooth !== undefined) lineSmooth.value = _lineSmooth as boolean
    if (_showLine !== undefined) showLine.value = _showLine
    if (_showArea !== undefined) showArea.value = _showArea
    if (_horizontalBars !== undefined) horizontalBars.value = _horizontalBars
    if (_donut !== undefined) donut.value = _donut
    if (_stackBars !== undefined) stackBars.value = _stackBars
  }

  themeColor.value = handleElement.value.themeColor
  gridColor.value = handleElement.value.gridColor || '#333'
  legend.value = handleElement.value.legend || ''
}, { deep: true, immediate: true })

const updateElement = (props: Partial<PPTChartElement>) => {
  slidesStore.updateElement({ id: handleElementId.value, props })
  addHistorySnapshot()
}

// 设置图表数据
const updateData = (data: ChartData) => {
  chartDataEditorVisible.value = false
  updateElement({ data })
}

// 设置填充色
const updateFill = (value: string) => {
  updateElement({ fill: value })
}

// 设置其他选项：柱状图转条形图、折线图转面积图、折线图转散点图、饼图转环形图、折线图开关平滑曲线
const updateOptions = (optionProps: ChartOptions) => {
  const _handleElement = handleElement.value as PPTChartElement

  const newOptions = { ..._handleElement.options, ...optionProps }
  updateElement({ options: newOptions })
}

// 设置主题色
const updateTheme = (color: string, index: number) => {
  const props = {
    themeColor: themeColor.value.map((c, i) => i === index ? color : c),
  }
  updateElement(props)
}

// 添加主题色
const addThemeColor = () => {
  const props = {
    themeColor: [...themeColor.value, theme.value.themeColor],
  }
  updateElement(props)
}

// 使用预置主题配色
const applyPresetTheme = (colors: string[], index: number) => {
  const themeColor = colors.slice(0, index + 1)
  updateElement({ themeColor })
  presetThemesVisible.value = false
}

// 删除主题色
const deleteThemeColor = (index: number) => {
  const props = {
    themeColor: themeColor.value.filter((c, i) => i !== index),
  }
  updateElement(props)
}

// 设置网格颜色
const updateGridColor = (gridColor: string) => {
  updateElement({ gridColor })
}

// 设置图例位置/不显示
const updateLegend = (legend: '' | 'top' | 'bottom') => {
  updateElement({ legend })
}

const openDataEditor = () => chartDataEditorVisible.value = true

emitter.on(EmitterEvents.OPEN_CHART_DATA_EDITOR, openDataEditor)
onUnmounted(() => {
  emitter.off(EmitterEvents.OPEN_CHART_DATA_EDITOR, openDataEditor)
})

return (_ctx: any,_cache: any) => {
  const _component_IconEdit = _resolveComponent("IconEdit")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_SelectOption = _resolveComponent("SelectOption")!
  const _component_Select = _resolveComponent("Select")!
  const _component_ColorPicker = _resolveComponent("ColorPicker")!
  const _component_Popover = _resolveComponent("Popover")!
  const _component_IconCloseSmall = _resolveComponent("IconCloseSmall")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_IconPlus = _resolveComponent("IconPlus")!
  const _component_ButtonGroup = _resolveComponent("ButtonGroup")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Button, {
      class: "full-width-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (chartDataEditorVisible.value = true))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_IconEdit, { class: "btn-icon" }),
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_Divider),
    (_unref(handleChartElement).chartType === 'line')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Checkbox, {
              onChange: _cache[1] || (_cache[1] = e => updateOptions({ showArea: e.target.checked })),
              checked: showArea.value,
              style: {"flex":"1"}
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(_component_Checkbox, {
              onChange: _cache[2] || (_cache[2] = e => updateOptions({ showLine: !e.target.checked })),
              checked: !showLine.value,
              style: {"flex":"1"}
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Checkbox, {
              onChange: _cache[3] || (_cache[3] = e => updateOptions({ lineSmooth: e.target.checked })),
              checked: lineSmooth.value
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["checked"])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_unref(handleChartElement).chartType === 'bar')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_Checkbox, {
            onChange: _cache[4] || (_cache[4] = e => updateOptions({ horizontalBars: e.target.checked })),
            checked: horizontalBars.value
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["checked"]),
          _createVNode(_component_Checkbox, {
            onChange: _cache[5] || (_cache[5] = e => updateOptions({ stackBars: e.target.checked })),
            checked: stackBars.value
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["checked"])
        ]))
      : _createCommentVNode("", true),
    (_unref(handleChartElement).chartType === 'pie')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_Checkbox, {
            onChange: _cache[6] || (_cache[6] = e => updateOptions({ donut: e.target.checked })),
            checked: donut.value
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }, 8, ["checked"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Divider),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createVNode(_component_Select, {
        style: {"flex":"3"},
        value: legend.value,
        onChange: _cache[7] || (_cache[7] = value => updateLegend(value as '' | 'top' | 'bottom'))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SelectOption, { value: "" }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _createVNode(_component_SelectOption, { value: "top" }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }),
          _createVNode(_component_SelectOption, { value: "bottom" }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    _createVNode(_component_Divider),
    _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _createVNode(_component_Popover, { trigger: "click" }, {
        content: _withCtx(() => [
          _createVNode(_component_ColorPicker, {
            modelValue: fill.value,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = value => updateFill(value))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, {
            color: fill.value,
            style: {"flex":"3"}
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _createVNode(_component_Popover, { trigger: "click" }, {
        content: _withCtx(() => [
          _createVNode(_component_ColorPicker, {
            modelValue: gridColor.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = value => updateGridColor(value))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, {
            color: gridColor.value,
            style: {"flex":"3"}
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Divider),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(themeColor.value, (color, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "row",
        key: index
      }, [
        _createElementVNode("div", _hoisted_22, _toDisplayString(index === 0 ? '主题配色：' : ''), 1),
        _createVNode(_component_Popover, { trigger: "click" }, {
          content: _withCtx(() => [
            _createVNode(_component_ColorPicker, {
              modelValue: color,
              "onUpdate:modelValue": value => updateTheme(value, index)
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(ColorButton, {
                color: color,
                style: {"width":"100%"}
              }, null, 8, ["color"]),
              _createVNode(_component_Tooltip, {
                mouseLeaveDelay: 0,
                mouseEnterDelay: 0.5,
                title: "删除"
              }, {
                default: _withCtx(() => [
                  (index !== 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "delete-color-btn",
                        onClick: _withModifiers(($event: any) => (deleteThemeColor(index)), ["stop"])
                      }, [
                        _createVNode(_component_IconCloseSmall)
                      ], 8, _hoisted_24))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["mouseEnterDelay"])
            ])
          ]),
          _: 2
        }, 1024)
      ]))
    }), 128)),
    _createVNode(_component_ButtonGroup, { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(_component_Popover, {
          trigger: "click",
          visible: presetThemesVisible.value,
          "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((presetThemesVisible).value = $event))
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_25, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(presetChartThemes, (item, index) => {
                return _createElementVNode("div", {
                  class: "preset-theme",
                  key: index
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (color, itemIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["preset-theme-color", { 'select': presetThemeColorHoverIndex.value[0] === index && itemIndex <= presetThemeColorHoverIndex.value[1] }]),
                      key: color,
                      style: _normalizeStyle({ backgroundColor: color }),
                      onClick: ($event: any) => (applyPresetTheme(item, itemIndex)),
                      onMouseenter: ($event: any) => (presetThemeColorHoverIndex.value = [index, itemIndex]),
                      onMouseleave: _cache[10] || (_cache[10] = ($event: any) => (presetThemeColorHoverIndex.value = [-1, -1]))
                    }, null, 46, _hoisted_26))
                  }), 128))
                ])
              }), 64))
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              class: "no-padding",
              style: {"flex":"2"}
            }, {
              default: _withCtx(() => [
                _hoisted_27
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["visible"]),
        _createVNode(_component_Button, {
          class: "no-padding",
          disabled: themeColor.value.length >= 10,
          style: {"flex":"3"},
          onClick: _cache[12] || (_cache[12] = ($event: any) => (addThemeColor()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconPlus, { class: "btn-icon" }),
            _hoisted_28
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    }),
    _createVNode(_component_Divider),
    _createVNode(ElementOutline),
    _createVNode(_component_Modal, {
      visible: chartDataEditorVisible.value,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((chartDataEditorVisible).value = $event)),
      footer: null,
      centered: "",
      closable: false,
      width: 648,
      destroyOnClose: ""
    }, {
      default: _withCtx(() => [
        _createVNode(ChartDataEditor, {
          data: _unref(handleChartElement).data,
          onClose: _cache[13] || (_cache[13] = ($event: any) => (chartDataEditorVisible.value = false)),
          onSave: _cache[14] || (_cache[14] = value => updateData(value))
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})